/**
 * doclist 接口的载荷
 *
 * data 类型 string 为 {@link DocListOptions} stringify 后的值
 */

// todo: 改为自动生成

/** 列表排序顺序类型 */
export var OrderType = /*#__PURE__*/function (OrderType) {
  OrderType[OrderType["Desc"] = 0] = "Desc";
  OrderType[OrderType["Asc"] = 1] = "Asc";
  return OrderType;
}({});

/** 文件来源类型 */
export var SourceType = /*#__PURE__*/function (SourceType) {
  SourceType[SourceType["All"] = 0] = "All";
  SourceType[SourceType["Me"] = 1] = "Me";
  SourceType[SourceType["Others"] = 2] = "Others";
  return SourceType;
}({});

/** 排序类型 */
export var SortType = /*#__PURE__*/function (SortType) {
  SortType[SortType["RecentUpdate"] = 1] = "RecentUpdate";
  SortType[SortType["RecentOpen"] = 2] = "RecentOpen";
  SortType[SortType["SortByName"] = 3] = "SortByName";
  return SortType;
}({});
export var DOC_LIST_URL = "//".concat(location.host, "/cgi-bin/online_docs/doclist");

/** 个性化背景. */

/** 个性化标题颜色. */
/** 租户. */
var Tenant = /*#__PURE__*/function (Tenant) {
  Tenant["None"] = "";
  Tenant["WeCom"] = "wecom";
  return Tenant;
}(Tenant || {});
/** 认证信息. */
/** 认证类型. */
var OfficialAuthType = /*#__PURE__*/function (OfficialAuthType) {
  OfficialAuthType[OfficialAuthType["None"] = 0] = "None";
  OfficialAuthType[OfficialAuthType["Enterprise"] = 1] = "Enterprise";
  OfficialAuthType[OfficialAuthType["EnterpriseMedia"] = 2] = "EnterpriseMedia";
  OfficialAuthType[OfficialAuthType["Government"] = 3] = "Government";
  OfficialAuthType[OfficialAuthType["NonProfitOrganization"] = 4] = "NonProfitOrganization";
  OfficialAuthType[OfficialAuthType["PrivateNonEnterprise"] = 5] = "PrivateNonEnterprise";
  OfficialAuthType[OfficialAuthType["ProfitOrganization"] = 6] = "ProfitOrganization";
  OfficialAuthType[OfficialAuthType["SocialGroup"] = 8] = "SocialGroup";
  OfficialAuthType[OfficialAuthType["PublicInstitutionMedia"] = 9] = "PublicInstitutionMedia";
  OfficialAuthType[OfficialAuthType["PublicInstitution"] = 11] = "PublicInstitution";
  OfficialAuthType[OfficialAuthType["IndividualCompany"] = 12] = "IndividualCompany";
  OfficialAuthType[OfficialAuthType["OverseaCompany"] = 13] = "OverseaCompany";
  return OfficialAuthType;
}(OfficialAuthType || {});
//# sourceMappingURL=doc-list.js.map